export default class Directives {
  public static splitContent(value: string, size: number): string {
    if (value) {
      const splitContent = () => {
        if (value.length > size) {
          return `${value.substring(0, size)}...`;
        }
        return value;
      };
      return splitContent();
    }
    return value;
  }

  public static toCurrency(value: number): string {
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });
    return formatter.format(value);
  }

  public static toDocument(document: any): string {
    if (document) {
      let stringDocument = `${document}`;
      const toDocument = () => {
        if (document.length === 14) {
          stringDocument = stringDocument.padStart(14, '0');
          stringDocument = stringDocument.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
          return stringDocument;
        }
        stringDocument = stringDocument.padStart(11, '0');
        stringDocument = stringDocument.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        return stringDocument;
      };
      return toDocument();
    }
    return document;
  }
}

export { Directives as VbDirectives };
